import Vue from 'vue';
import axios from "axios";

import VueAxios from "vue-axios";

import JwtService from "../common/jwt.service";
import { API_URL } from "../common/config";

const ApiService = {

   init() {
       Vue.use(VueAxios, axios);
       Vue.axios.defaults.baseURL = API_URL;
       Vue.axios.interceptors.request.use(config => {
           // NProgress.start();
           return config;
       });

       Vue.axios.interceptors.response.use(
           response => {
               // NProgress.done();
               return response;
           }, error => {
               // NProgress.done();
               return error.response;
           });
   },

   setHeader() {
        this.init();
       Vue.axios.defaults.headers.common = {
           'X-Requested-With': 'XMLHttpRequest',
           "Authorization": `Bearer ${atob(JwtService.getToken())}`
       };
   },

   setMultipartHeader() {
        this.init();
       Vue.axios.defaults.headers.common = {
           'X-Requested-With': 'XMLHttpRequest',
           'content-type': 'multipart/form-data',
           "Authorization": `Bearer ${atob(JwtService.getToken())}`,
       };
   },

   get(resource, slug = "") {
        this.init();
       return Vue.axios.get(`${resource}/${slug}`).catch(error => {
           throw new Error(`[RWV] ApiService ${error}`);
       });
   },

   post(resource, params) {
        this.init();
       return Vue.axios.post(`${resource}`, params);
   },

   put(resource, params) {
        this.init();
       return Vue.axios.put(`${resource}`, params);
   },
   delete(resource, params) {
        this.init();
       return Vue.axios.delete(`${resource}`, params);
   }

};


export default ApiService;
